import { Platform } from 'react-native';

import { Theme } from '@providers/Theme/theme';

import { StyleObj } from '../types';

export type ShadowMixinArgs = {
  color: string | ((theme: Theme) => string | undefined);
  opacity: number;
  radius: number;
  offsetWidth: number;
  offsetHeight: number;
  elevation: number;
  spreadRadius?: string;
  radiusRGBColor?: string;
};

export type ShadowMixin = (input: ShadowMixinArgs) => StyleObj | undefined;

export const shadowMixin: ShadowMixin = (input) => {
  return Platform.select({
    ios: {
      shadowColor: input.color,
      shadowRadius: input.radius,
      shadowOpacity: input.opacity,
      shadowOffset: {
        width: input.offsetWidth,
        height: input.offsetHeight,
      },
    },
    android: {
      elevation: input.elevation,
    },
    web: {
      boxShadow: `${input.offsetWidth}px ${input.offsetHeight}px ${
        input.radius
      }px ${
        input.radiusRGBColor
          ? `rgba(${input.radiusRGBColor}, ${input.opacity})`
          : ''
      }, ${input.spreadRadius && input.spreadRadius} ${input.color}`,
      // 0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03);
      // w   h    r
    },
  }) as StyleObj;
};
